<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Secured By Design';
                }
            },
            component_id: {
                default(){
                    return 'secured_by_design';
                }
            },
            collection: {
                required: false,
                default() {
                    return 0;
                }
            },
            typeRange: {
                required: false,
                default() {
                    return 0;
                }
            },
            category: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.fabricator, this.collection, this.typeRange, this.category);
            },
            url(){
                return '/api/options/' + this.fabricator + '/secured-by-design?collection=' + this.collection + '&type_range=' + this.typeRange + '&category=' + this.category;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.collection + '_' + this.typeRange + '_' + this.category;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
